























































































































































































import { Component, Vue } from 'vue-property-decorator';
import '../assets/css/submitDraftTransport.scss';
import { validationMixin } from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { CommonUtils } from '@/util/commonUtils';
import { DraftTransportRequest } from '@/types/entity';
import MessageBox from '../components/MessageBox.vue';
import { Address } from '@/types/request';
import { MapUtils } from '@/util/mapUtils';
declare var google: any;
@Component({
    components: {
      MessageBox,
    },
    mixins: [validationMixin],
    props: {
        submitRequest: Object,
    },
    data() {
        return {
            patientName: '',
            patientEmail: '',
            patientPhone: '',
            appointmentDate: '',
            appointmentTime: '',
            visitType: 'PROCEDURE',
            vehicleType: '',
            healthcareProviderName: '',
            healthcareProviderEmail: '',
            pickupAddress: '',
            dropoffAddress: '',
            isConciergeServiceRequired: false,
            billingLocationId: '',
        };
    },
    validations() {
        const validations = {
            billingLocationId: {
                required,
            },
            patientName: {
                required,
            },
            patientEmail: {
                required,
                email,
            },
            patientPhone: {
                required,
                minLength: minLength(10),
                regex: (patientPhone: string) => MedTransGoConstants.PHONE_REGX.test(patientPhone),
            },
            appointmentDate: {
                required,
            },
            appointmentTime: {
                required,
            },
            visitType: {
                required,
            },
            vehicleType: {
                required,
            },
            healthcareProviderName: {
                required,
            },
            healthcareProviderEmail: {
                required,
                email,
            },
            pickupAddress: {
                required,
            },
            dropoffAddress: {
                required,
            },
        };
        return validations;
    },
    computed: {
      formattedAppointmentTime() {
        if (!this.$data.appointmentTime) {
          return '';
        }
        const [hours, minutes] = this.$data.appointmentTime.split(':');
        const formattedHours = hours % 12 || 12;
        const amPm = hours >= 12 ? 'PM' : 'AM';
        return `${formattedHours}:${minutes} ${amPm}`;
      },
    },
    watch: {
      formattedAppointmentTime(newValue) {
        if (newValue !== this.$data.appointmentTime) {
          const [time, period] = newValue.split(' ');
          const [hours, minutes] = time.split(':');
          let formattedHours = parseInt(hours, 10);
          if (period === 'PM' && formattedHours !== 12) {
            formattedHours += 12;
          } else if (period === 'AM' && formattedHours === 12) {
            formattedHours = 0;
          }
          this.$data.appointmentTime = `${String(formattedHours).padStart(2, '0')}:${minutes}`;
        }
      },
    },
})
export default class SubmitRequest extends Vue {
    private billingLocations: any = [];
    private errorMessage = '';
    private showError = true;
    private patientAddresses: Address[] = [] as any;
    private providerDetails: { name: string, email: string} = {} as any;
    private memberDetails: {
      phone: string;
      email: string;
      name: string;
    } = {} as any;
    private isRideCreditRequest = false;
    private pickupGoogleAddress: any;
    private dropoffGoogleAddress: any;

    private mounted() {
        if (!this.$route.params.id) {
            this.redirectToLogin();
        }
        this.getDraftRequestDetails();
    }

    private redirectToLogin() {
        const redirectUrl = `${this.$store.state.serverUrl}${MedTransGoConstants.HTTP_URL_LOGIN}?clientId=${this.$store.state.clientId}`;
        location.href = redirectUrl;
    }

    private async getDraftRequestDetails() {
      const response = await ObjectFactory.getRequestService().
        getDraftRequestDetails(this.$route.params.id as string,
      this.$store.state.serverUrl);
      if (!response.success || !response.data) {
        this.redirectToLogin();
      } else if (response.data) {
        this.billingLocations = response.data.billingLocations;
        if (response.data.draftRequest.billingLocationId) {
          this.$data.billingLocationId = response.data.draftRequest.billingLocationId;
        }
        if (response.data.draftRequest.patientInfo && response.data.draftRequest.patientInfo.address.length > 0) {
          this.patientAddresses = response.data.draftRequest.patientInfo.address;
        }
        if (response.data.draftRequest.isRideCreditRequest) {
          this.isRideCreditRequest = true;
        } else {
          this.pickupGoogleAddress = new google.maps.places.Autocomplete(this.$refs.pickupGoogleAddress,
                { types: ['geocode'] });
          this.pickupGoogleAddress.addListener('place_changed', () => {
              this.$data.pickupAddress = MapUtils.parseGoogleAddress(this.pickupGoogleAddress).fullAddress;
          });
          this.dropoffGoogleAddress = new google.maps.places.Autocomplete(this.$refs.dropoffGoogleAddress,
                { types: ['geocode'] });
          this.dropoffGoogleAddress.addListener('place_changed', () => {
              this.$data.dropoffAddress = MapUtils.parseGoogleAddress(this.dropoffGoogleAddress).fullAddress;
          });
        }
        if (response.data.draftRequest.memberInfo) {
          const memberInfo = response.data.draftRequest.memberInfo;
          this.memberDetails = {
            email: memberInfo.email,
            name: memberInfo.name,
            phone: memberInfo.phone,
          };
        }
        const draftRequest = response.data.draftRequest;
        this.$data.vehicleType = draftRequest.vehicleType ? draftRequest.vehicleType : '';
        if (draftRequest.patientInfo) {
          this.$data.patientName = draftRequest.patientInfo.fullName;
          this.$data.patientPhone = draftRequest.patientInfo.phone;
          this.$data.patientEmail = draftRequest.patientInfo.email;
        }
        this.$data.pickupAddress = draftRequest.pickupAddress;
        this.$data.dropoffAddress = draftRequest.dropoffAddress;
        this.$data.appointmentDate = draftRequest.appointmentDate;
        this.$data.appointmentTime = draftRequest.appointmentTime;
        if (draftRequest.healthcareProviderInfo) {
          this.$data.healthcareProviderName = draftRequest.healthcareProviderInfo.name;
          this.$data.healthcareProviderEmail = draftRequest.healthcareProviderInfo.email;
        }
      }
    }

    private async submitDraftRequest() {
      const draftRequest: DraftTransportRequest = {
        billingLocationId: this.$data.billingLocationId,
        visitType: this.$data.visitType,
        vehicleType: this.$data.vehicleType,
        isConciergeServiceRequired: this.$data.isConciergeServiceRequired ? true : false,
        patientInfo: {
          fullName: this.$data.patientName,
          phone: this.$data.patientPhone,
          email: this.$data.patientEmail,
        },
        appointmentDate: this.$data.appointmentDate,
        appointmentTime: this.$data.appointmentTime,
        healthcareProviderInfo: {
          name: this.$data.healthcareProviderName,
          email: this.$data.healthcareProviderEmail,
        },
        pickupAddress: this.$data.pickupAddress,
        dropoffAddress: this.$data.dropoffAddress,
      };
      const response = await ObjectFactory.getRequestService().
        submitDraftRequestDetails(this.$route.params.id as string,
      this.$store.state.serverUrl, draftRequest);
      if (response.success) {
        this.errorMessage = '';
        const messageBox: any = this.$refs.messageBox;
        messageBox.showModal();
      } else if (response.errors && response.errors.length && response.errors[0]) {
        this.errorMessage = response.errors[0];
      } else if (response.errorCode) {
        this.errorMessage = CommonUtils.translateErrorCode(response.errorCode);
      }
    }

    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }

}
